// components

// react
import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";
import { Switch } from "@progress/kendo-react-inputs";
import { Dialog, DialogActionsBar, Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Checkbox } from '@progress/kendo-react-inputs';

// css
import styles from './account_mobile.module.css';
import "./account_mobile.css";

// services
import { getAccountInfo, setUpdateAccountInfoMobile } from '../../../service/mngt/accoutMngtService';
import { authGuest, setDelToken, setToken, isLogin, getUser } from "../../../service/authService";
import { getPublicKey, setSubscription, deleteSubscription, setPush, checkSubscription, setPushTime } from "../../../service/pushService";
// import { userSubscription, pushSubscribe, pushUnsubscribe } from "../../../index";
// import {getFCMToken, deleteFCMToken, requestPermission} from "../../../firebase-messaging-sw.js"
import { initializeApp } from "firebase/app";
import { deleteToken, getMessaging, getToken, onMessage } from "firebase/messaging";

function AccountMobile({conn, setUpdateLoginStatus, loginStatus}) {
  const firebaseConfig = {
    apiKey: "AIzaSyDDmTePQlSYVn6APk9uZ2STomM7LO_tgiU",
    authDomain: "chcare-6814c.firebaseapp.com",
    projectId: "chcare-6814c",
    storageBucket: "chcare-6814c.appspot.com",
    messagingSenderId: "147040215420",
    appId: "1:147040215420:web:227c24029711cb2e1944f9",
    measurementId: "G-NP9HYHWSL5"
  };
  // Initialize Firebase
  const APP = initializeApp(firebaseConfig);
  const MESSAGING = getMessaging(APP);
  
  // Get the FCM token for the current device
  const getFCMToken = () => {
    console.log("Get Token");
    return getToken(MESSAGING, { vapidKey: "BGkXXrzIHiGuXIN9V4mf-zuHlsK3CZEjEPYYcOqT-J4Ad4N0dazIvtTjMpURR2dmuzopb4xabSoR3YWz3BtALjw" });
  };
  
  // Delete the FCM token for the current device
  const deleteFCMToken = () => {
    console.log("Delete Token");
    return deleteToken(MESSAGING);
  };

  const userInfo = getUser();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  // 모바일 기종
  const [phoneModel, setPhoneModel] = useState("");

  const [accountInfo, setAccountInfo] = useState({
    userTerm: null,
    userId: null,
    protectorPhone: null,
    userPassword: null,
    userPasswordCheck: null,
    push: null,
    pushTime: null,
    changed: false,
  });

  // // 푸시 정보
  // const [pushInfo, setPushInfo] = useState({
  //   userId: null,
  //   push: null,
  //   subscription : null,
  // })

  // 구독 정보
  const [subscriptionInfo, setSubscriptionInfo] = useState({
    subscriptionId: null,
    userId: null,
    gathDtm: new Date(),
    userSubscription: null,
  })
  // DIALOG 설정
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [questionDialogVisible, setQuestionDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("확인을 눌러주세요.");
  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }
  const saveQuestionDialog = () => {
    setUpdateAccountInfoMobile(conn, accountInfo)
    .then(response => {
      setDialogMessage("변경이 완료되었습니다.");
      setCompleteDialogVisible(true);
      window.location.replace('/account');
    })
    .catch(error => console.log('setUpdateAccountInfo Error', error));
    setQuestionDialogVisible(false);
  }
  const closeQuestionDialog = () => {
    setQuestionDialogVisible(false);
  }

  // 연락처 설정
  const changePhone = (e) => {
    setAccountInfo({ ...accountInfo, protectorPhone: e.target.value });
  }

  // 비밀번호 설정
  const changePassword = (e) => {
    if (e.target.name === 'userPassword') {
      setAccountInfo({ ...accountInfo, userPassword: e.target.value });
    } else if (e.target.name === 'userPasswordCheck') {
      setAccountInfo({ ...accountInfo, userPasswordCheck: e.target.value });
    }
  };

  const saveAccountInfo = () => {
    // 여기서 Validaion 처리
    // 1-1 PASSWORD 확인 및 이전 PASSWORD 처리 있는가?
    if (accountInfo.userPassword !== '') {
      if (accountInfo.userPassword !== accountInfo.userPasswordCheck) {
        setDialogMessage("입력하신 두 개의 비밀번호가 일치하지 않습니다. 다시 시도해주세요.");
        setCompleteDialogVisible(true);
        // kendo.alert('입력하신 변경된 비밀번호와 확인 비밀번호와 맞지 않습니다. 다시 확인하시고 똑같이 입력 해주세요.');
        return;
      } else {
        // 비밀번호 정규식 (영어 대문자, 소문자 포함 숫자 포함 특수문자 포함 8자리 이상)
        const regPassword = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/;
        // const regPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*+=-]).{9,15}$/;
        if (!regPassword.test(accountInfo.userPassword)) {
          setDialogMessage("영어, 숫자, 특수문자 포함한 8자리 이상 15자리 미만으로 작성해주세요.");
          setCompleteDialogVisible(true);
          // kendo.alert('유효하지 않은 비밀번호입니다! 영어 ,숫자,특수문자 포함한 8자리 이상 15자 미만으로 작성해주세요.');
          return;
        }
      }
    }

    // 3-1 휴대폰 번호 처리
    const regPhone = /[01](0|1|6|7|8|9)-(\d{4}|\d{3})-\d{4}$/;
    if (accountInfo.protectorPhone && !regPhone.test(accountInfo.protectorPhone)) {
      setDialogMessage("유효하지 않은 개인 연락처 번호입니다.");
      setCompleteDialogVisible(true);
      // kendo.alert('유효하지 않은 개인 연락처 번호입니다!');
      return;
    }

    setDialogMessage("변경된 정보를 저장하시겠습니까?");
    setQuestionDialogVisible(true);

  }
 
  // PUSH 알림
  // Notification.requestPermission(status => {}) : 권한 여부 묻기
  // Notification.permission : 권한 여부 확인 -> 값 변경은 X 사용자가 직접 하드웨어 알림 설정을 해야함

  // 사용자 구독 정보
  // let userSubscription = null;
  // 공개키
  let publicKey = "BGkXXrzIHiGuXIN9V4mf-zuHlsK3CZEjEPYYcOqT-J4Ad4N0dazIvtTjMpURR2dmuzopb4xabSoR3YWz3BtALjw";

  // 입력으로 받은 데이터를 Uint8Array 타입으로 변환합니다.
  const urlB64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; i++) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  // 푸시 구독
  const pushSubscribe = () => {
    getFCMToken()
    .then((token) => {
      console.log("FCM token = ", token);
      setSubscriptionInfo(subscriptionInfo => {
          const item = { ...subscriptionInfo };
          item.subscriptionId = token;
          setSubscription(conn, item);
          return item;
      })
      setAccountInfo(accountInfo => {
        const item = { ...accountInfo };
        item.push = "Y"
        setPush(conn, item);
        return item;
      })
      setLoading(false);
    })
    .catch((err) => {
      console.error("FCM token get err = ", err);
    })
    console.log("subscriptionInfo.userSubscription : ",subscriptionInfo.userSubscription);
  };

  // 푸시 구독 취소
  const pushUnsubscribe = () => {
    console.log("푸시 구독 취소");
    deleteSubscription(conn, subscriptionInfo);
    deleteFCMToken()
    .then(() => {
      console.log("FCM token deleted.");
      setAccountInfo(accountInfo => {
        const item = { ...accountInfo };
        item.push = "N"
        setPush(conn, item);
        return item;
      })
      setLoading(false);
    })
    .catch((err) => {
      console.log("FCM token delete err = ", err);
    })
    console.log("subscriptionInfo.userSubscription : ",subscriptionInfo.userSubscription);
  }
  
  // Notification TEST
  const displayNotification = () => {
    if(Notification.permission === 'granted') {
      if(accountInfo.push === "Y") {
        navigator.serviceWorker.getRegistration()
          .then(reg => {
            const options = {
              body: '푸시알림 테스트 입니다.',
              icon: '/images/mobile/app_logo192x192.png',
              vibrate: [100, 50, 100], // 진동패턴 100, 50, 100 밀리초 순서
              data: { primaryKey: 1 } // 사용자가 알림과 상호작용할 때 서비스 워커를 통해 검색할 수 있는 임의의 데이터
              // badge: 'path/to/badge.png'
            };
            reg.showNotification('JKCORE', options);
          })
      } else {
        return;
      }
    }
  }

  // 알림수신여부 설정
  const changePush = (e) => {
    setLoading(true);
    if(Notification.permission === 'denied') {
      setDialogMessage("설정에서 안심박스 알림 허용이 필요합니다.");
      setCompleteDialogVisible(true);
    }
    if(!e.value) { // 알림수신여부 N
      if(Notification.permission !== 'granted') {
        return;
      } else {
        pushUnsubscribe();
        setDialogMessage("푸시 알림 설정이 꺼졌습니다.");
        setCompleteDialogVisible(true);
      }
    } else { // 알림수신여부 Y
      // 사용자에게 알림 권한 여부 묻기 
      Notification.requestPermission(status => {
        console.log("Notification permission status:", status);
        
        if(Notification.permission !== 'granted') {
          return;
        } else {
          // setSubscription(conn, subscriptionInfo)
          pushSubscribe();
          setDialogMessage("푸시 알림 설정이 켜졌습니다.");
          setCompleteDialogVisible(true);
        }
      })
    }  
  }

  // 알림수신시간 설정
  const checkboxEvent = (e) => {
    if(e.value) {
      if(e.target.element.id === "allTime") {
        setAccountInfo(accountInfo => {
          const item = { ...accountInfo, pushTime: "ALL"};
          setPushTime(conn, item);
          return item;
        })
      } else if(e.target.element.id === "workTime") {
        setAccountInfo(accountInfo => {
          const item = { ...accountInfo, pushTime: "WORK" };
          setPushTime(conn, item);
          return item;
        })
      }
    } else {
      if(e.target.element.id === "allTime") {
        setAccountInfo(accountInfo => {
          const item = { ...accountInfo, pushTime: "WORK" };
          setPushTime(conn, item);
          return item;
        })
      } else if(e.target.element.id === "workTime") {
        setAccountInfo(accountInfo => {
          const item = { ...accountInfo, pushTime: "ALL"};
          setPushTime(conn, item);
          return item;
        })
      }
    }

  }

  useEffect(() => {
    if(/Android/.test(navigator.userAgent)) {
      setPhoneModel("andrioid");
    } else if(/iPhone|iPad|iPd/.test(navigator.userAgent)) {
      setPhoneModel("ios");
    }
  }, [location]);

  useEffect(() => {
    setLoading(true); // 로딩 설정
    const search = {
      userId: userInfo.userId,
    };
  
    console.log("InitializeApp at account_mobile");
    getAccountInfo(conn, search)
      .then(response => {
        response.userPassword = '';
        // setPushInfo(pushInfo => {
        //   const item = { ...pushInfo };
        //   item.userId = response.userId;
        //   item.push = response.push;
        //   return item;
        // });
        // 구독 정보 저장 (userId)
        setSubscriptionInfo(subscriptionInfo => {
          const item = { ...subscriptionInfo }
          item.userId = response.userId;
          return item;
        })
        setAccountInfo(response);
      })
      .catch(error => console.log('getAccountInfo Error!', error));

      getFCMToken()
      .then((token) => {
        setSubscriptionInfo(subscriptionInfo => {
          const item = { ...subscriptionInfo }
          item.subscriptionId = token;
          checkSubscription(conn, item).then((result)=>{
            setSubscriptionInfo(subscriptionInfo => {
              const item = { ...subscriptionInfo }
              item.userSubscription = result;
              return item;
            })
            if(result){
              setAccountInfo(accountInfo => {
                const item = { ...accountInfo };
                item.push = "Y"
                return item;
              })
            }
            else{
              setAccountInfo(accountInfo => {
                const item = { ...accountInfo };
                item.push = "N"
                return item;
              })
            }
          })
          return item;
        })
        setLoading(false);
      })
      .catch((err) => {
        console.error("At UseEffect, FCM token get err = ", err);
        setLoading(false);
      })
      .finally(() => {
        // 버튼 제어
      })
  }, []);

  return (
    <>
      <div className="pageContent_m">
        <div className="myAccount">
          <div className="accountTitle">이름 (아이디)</div>
          <div className="accountContent" style={{background: "#ededed", border: "none", height: "6vw"}}>
            <p className="content_01">{accountInfo.userTerm}({accountInfo.userId})</p>
          </div>
          <div className="accountTitle">핸드폰 번호</div>
          <div className="accountContent">
            <input className="content_02" placeholder="010-0000-0000" value={accountInfo.protectorPhone} onChange={changePhone} autocomplete="off"/>
          </div>
          <div className="accountTitle">새 비밀번호</div>
          <div className="accountContent">
            <input className="content_02" placeholder="8자 이상 15자 이하 영문, 숫자, 특수문자 조합" type="password" name="userPassword" onChange={changePassword}/>
          </div>
          <div className="accountTitle">새 비밀번호 확인</div>
          <div className="accountContent">
            <input className="content_02" placeholder="비밀번호 확인" type="password" name="userPasswordCheck" onChange={changePassword}/>
          </div>
          {/* 아이폰일 경우 알림 기능 보류 */}
          {/* {
          phoneModel === "ios" ? 
            null :
            <> */}
              
              {/* <div className="accountContent" style={{border: "none", padding: "0"}}>
                <button onClick={displayNotification}>알림 테스트</button>
              </div> */}
            {/* </>
          } */}
          <br></br>
          <div className="accountContent"  style={{border: "none", padding: "0", display: "grid"}}>
            <button className="accountUpdateBtn" onClick={saveAccountInfo}>수정</button>
          </div>
          <br></br><br></br>
          <div className="accountTitle">알림수신여부</div>
            <div className="accountContent" style={{border: "none", padding: "0"}}>
            <Switch 
              className="pushSwitch"
              checked={accountInfo.push === 'Y' ? true : false}
              name="push"
              onChange={changePush}
            />
          </div>
          {accountInfo.push === 'Y' ?
          <>
            <div className="accountTitle">알림수신시간</div>
            <div className="checkboxDiv">
              <div className="checkbox">전체시간<Checkbox id="allTime" checked={accountInfo.pushTime === "ALL"} label={false} onChange={checkboxEvent}/></div>
              <div className="checkboxText">- 상시 알림 허용</div>
              <div className="checkbox">업무시간<Checkbox id="workTime" checked={accountInfo.pushTime === "WORK"} label={false} onChange={checkboxEvent}/></div>
              <div className="checkboxText">- 평일 오전9시부터 오후 6시</div>
            </div>
          </> : null
          }
        </div>
        {completeDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={closeCompleteDialog}>확인</button>
            </p>
          </Dialog>
        )}
        {questionDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={saveQuestionDialog}>확인</button>
              <button style={{ color: "black", background: "#dddddd", marginLeft: "2vw"}} onClick={closeQuestionDialog}>취소</button>
            </p>
          </Dialog>
        )}
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default AccountMobile;
